import {FormularData} from '@/model/form-data';
import {Product} from '@/model/product';

export function getSelectedProduct(formData: FormularData, products: Product[]): Product {
  const product = products.find(product => product.intention === formData.intention);
  if (!product) {
    throw new Error('Chosen intention is not connected to a product');
  }
  return product;
}
